import Route from '@ember/routing/route';

export default class MilestonesRoute extends Route {}
